<template>
  <div class="business-wrapper">
    <header>
      <img src="../assets/backimg4.png" alt="">
    </header>
    <section>
      <div class="sectionTop">
        <p>主营业务</p>
        <div></div>
      </div>
      <div class="sectionCont">
        <div class="cont">
          <dl @click="tabChange('supplier')">
            <dt>
              <img src="../assets/电商仓配1.png" alt="">
            </dt>
            <dd>
              <p>电商仓配</p>
              <p>为电商提供一站式仓储配送服务以及保税业务</p>
            </dd>
          </dl>
          <dl @click="tabChange('container')">
            <dt>
              <img src="../assets/集运转运1.png" alt="">
            </dt>
            <dd>
              <p>集运转运</p>
              <span>（EMS/DHL/自营专线）</span>
              <p>免费 仓储/打包/加固</p>
            </dd>
          </dl>
          <dl @click="tabChange('express')">
            <dt>
              <img src="../assets/快件1.png" alt="">
            </dt>
            <dd>
              <p>快件进口和BC直购</p>
              <p>收费合理透明/清关快捷安全 </p>
            </dd>
          </dl>
          <dl @click="tabChange('software')">
            <dt>
              <img src="../assets/软件1.png" alt="">
            </dt>
            <dd>
              <p>软件服务支持</p>
              <p>自主研发团队/提供软件服务</p>
            </dd>
          </dl>
        </div>
      </div>
      <Supplier v-if="tabType == 'supplier'"></Supplier>
      <Container v-if="tabType == 'container'"></Container>
      <Express v-if="tabType == 'express'"></Express>
    </section>
  </div>
</template>
<script>
import Supplier from '../components/Supplier'
import Container from '../components/Container'
import Express from '../components/Express'
import { mapState } from 'vuex'
export default {
  name:'Business',
  props:{

  },
  components:{
    Supplier,
    Container,
    Express
  },
  data(){
    return {
    }
  },
  computed:{
    ...mapState({
      tabType:state=>state.tabType,
    })
  },
  methods:{
    tabChange(type){
      this.$store.commit('tabChange', type);
    },
  },
}
</script>
<style scoped lang="scss">
.business-wrapper {
  width: 100%;
  height: 100%;
}
section {
  margin: 30px 0;
  margin-bottom: 80px;
}
.sectionCont {
  background: #f5f5f5;
  .cont {
    width: 1000px;
    margin: 10px auto;
    display: flex;
    padding: 50px 0;
    box-sizing: border-box;
    dl {
      flex: 1;
      margin: 0 10px;
      background: #f9fbff;
      padding-bottom: 5px;
      box-sizing: border-box;
      box-shadow: 0 2px 2px 0 #ccc;
      cursor: pointer;
      dt {
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 0.4s;
      }
      dt:hover {
        background: #e5e5e5;
      }
      dd {
        height: 80px;
        background: $bg-color;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        box-sizing: border-box;
        p {
          text-align: center;
          font-size: 18px;
          margin: 2px;
        }
        p:nth-child(2),p:nth-child(3) {
          font-size: 13px;
        }
        span {
          font-size: 14px;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/view/Business.vue